module.exports = __webpack_public_path__ + "img/ft1.62a588cd.jpeg";